import React from 'react';

const ArrowDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8.231"
      height="6.076"
      viewBox="0 0 8.231 6.076"
    >
      <path
        id="Shape"
        d="M5.991,3.954.307.034A.2.2,0,0,0,0,.2v7.84A.2.2,0,0,0,.307,8.2l5.684-3.92a.2.2,0,0,0,0-.323Z"
        transform="translate(8.231) rotate(90)"
      />
    </svg>
  );
};

export default ArrowDownIcon;
